export default "__VITE_ASSET__1fb5f271__"